// hooks/useWalletTransactions.js
import { useMutation, useQuery } from "@tanstack/react-query";
import { getWalletTransactions } from "../wallet";
import { buyAirtime, getCableSubscriptions, getDataBundles, purchaseDataBundle, purchaseElectricity, subscribeCableTV, verifyMeter, verifySmartCard } from "../../repository/payment";

export const useWalletTransactions = (wallets) => {
  return useQuery({
    queryKey: ["wallet-transactions", wallets],
    queryFn: async () => {
      if (!wallets || wallets.length === 0) return [];

      const allTransactions = await Promise.all(
        wallets.map(async (wallet) => {
          try {
            const res = await getWalletTransactions({
              wallet_number_or_uuid: wallet.wallet_number || wallet.id,
            });

            let txs = res?.data?.transactions?.data || [];

            // Add wallet info
            return txs.map((tx) => ({
              ...tx,
              wallet_info: wallet,
            }));
          } catch (error) {
            console.error(
              `Failed to fetch transactions for wallet ${wallet.wallet_number}:`,
              error
            );
            return [];
          }
        })
      );

      // Flatten + sort
      return allTransactions
        .flat()
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    },
    enabled: !!wallets && wallets.length > 0, // only run if wallets exist
  });
};

export const useCableSubscriptions = (cable_tv_type) => {
  return useQuery({
    queryKey: ["wallet-transactions", cable_tv_type],
    queryFn: getCableSubscriptions(cable_tv_type),
    enabled: false,

  });
};

export const useDataBundle = (dataBundle) => {
  return useQuery({
    queryKey: ["data-bundles", dataBundle],
    queryFn: () => getDataBundles(dataBundle),
    enabled: dataBundle !== undefined,
  });
};

// Login
export const useAirtimePurchase = (transferRequest) => {
  console.log(transferRequest, "Airtim Request payload");

  return useMutation({
    mutationFn: buyAirtime,
    onSuccess: (data) => {
      // @ts-ignore
      return data?.data;
    },
    onError: (error) => {
      // @ts-ignore
      console.error("Login failed:", error?.response?.data);

      // @ts-ignore
      return error?.response?.data;
    },
  });
};
// Login
export const usePurchaseData = (transferRequest) => {
  console.log(transferRequest, "Airtim Request payload");

  return useMutation({
    mutationFn: purchaseDataBundle,
    onSuccess: (data) => {
      // @ts-ignore
      return data?.data;
    },
    onError: (error) => {
      // @ts-ignore
      console.error("Login failed:", error?.response?.data);

      // @ts-ignore
      return error?.response?.data;
    },
  });
};

export const useVerifyMeter = (transferRequest) => {
  console.log(transferRequest, "verify meter Request payload");

  return useMutation({
    mutationFn: verifyMeter,
    onSuccess: (data) => {
      // @ts-ignore
      return data?.data;
    },
    onError: (error) => {
      // @ts-ignore
      console.error("Login failed:", error?.response?.data);

      // @ts-ignore
      return error?.response?.data;
    },
  });
};

export const useVerifySmartCard = (transferRequest) => {
  console.log(transferRequest, "verify meter Request payload");

  return useMutation({
    mutationFn: verifySmartCard,
    onSuccess: (data) => {
      // @ts-ignore
      return data?.data;
    },
    onError: (error) => {
      // @ts-ignore
      console.error("Login failed:", error?.response?.data);

      // @ts-ignore
      return error?.response?.data;
    },
  });
};

export const useSubscribeCableTV = (transferRequest) => {
  console.log(transferRequest, "Subscribe cabletv Request payload");

  return useMutation({
    mutationFn: subscribeCableTV,
    onSuccess: (data) => {
      // @ts-ignore
      return data?.data;
    },
    onError: (error) => {
      // @ts-ignore
      console.error("Login failed:", error?.response?.data);

      // @ts-ignore
      return error?.response?.data;
    },
  });
};

export const usePurchaseElectricity = (transferRequest) => {
  console.log(transferRequest, "Subscribe cabletv Request payload");

  return useMutation({
    mutationFn: purchaseElectricity,
    onSuccess: (data) => {
      // @ts-ignore
      return data?.data;
    },
    onError: (error) => {
      // @ts-ignore
      console.error("Login failed:", error?.response?.data);

      // @ts-ignore
      return error?.response?.data;
    },
  });
};
